
<template>
  <el-card class="fitness-index">
    <!-- 添加 -->
    <template>
      <el-tooltip
        class="margin: 4px"
        effect="dark"
        :content="$t('tooltip.back_list')"
        placement="bottom">
        <el-button
          style="float:left"
          type="success"
          icon="iconfont icon-fitness-chehuisekuai"
          circle
          @click="handleBack()"
        ></el-button>
      </el-tooltip>
      <el-tooltip
        class="margin: 4px"
        effect="dark"
        :content="$t('tooltip.new_place')"
        placement="bottom">
        <el-button
          style="float:left"
          type="primary"
          icon="iconfont icon-fitness-tianjiawenjianjia"
          circle
          @click="handleEdit()"
        ></el-button>
      </el-tooltip>
    </template>
    <el-table :data="tableData" class="my-4" v-loading="loading">
      <el-table-column prop="id" :label="$t('Common.id')" align="center"/>
      <el-table-column prop="name" :label="$t('Store.Place.placename')" align="center"/>
      <el-table-column prop="capacity" :label="$t('Store.Place.galleryful')" align="center"/>
      <el-table-column prop="active" :label="$t('Store.Place.state_normal')" align="center">
        <template slot-scope="{$index, row}" v-if="row.active !== ''">
            {{ row.active ? $t('Common.yes') : $t('Common.no') }}
        </template>
      </el-table-column>
      <!-- 编辑 -->
      <el-table-column :label="$t('tooltip.edit')" fixed="right" align="center" width="200">
        <template slot-scope="{$index, row}">
          <el-tooltip class="margin: 4px" effect="dark" :content="$t('tooltip.edit')" placement="bottom">
            <el-button type="primary" icon="el-icon-edit" circle @click="handleEdit(row)"/>
          </el-tooltip>

          <el-tooltip
            class="margin: 4px"
            effect="dark"
            :content="$t('Store.Place.recover_place')"
            placement="bottom"
            v-if="row.active==false"
          >
            <el-button
              type="warning"
              icon="iconfont icon-fitness-huifu"
              circle
              @click="handleRestore($index, row)"
            />
          </el-tooltip>
          <el-tooltip
            class="margin: 4px"
            effect="dark"
            :content="$t('tooltip.delete')"
            placement="bottom"
            v-if="row.active==true"
          >
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              @click="handleDelete($index, row)"
            />
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!-- 弹窗 -->
    <el-dialog :title="form.id ? '编编门店场地' : '新增门店场地'" :visible.sync="visible">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        :status-icon="true"
        label-width="130px"
        label-suffix=" : "
        label-position="right"
        v-loading="form_loading"
      >
        <el-form-item :label="$t('Store.Place.recover_place')" prop="name">
          <el-input v-model.trim="form.name"/>
        </el-form-item>
        <el-form-item :label="$t('Store.Place.galleryful')" prop="capacity">
          <el-input v-model.trim.number="form.capacity"/>
        </el-form-item>
      </el-form>
      <el-button type="primary" slot="footer" @click="onSubmit">{{ $t('Message.confirm') }}</el-button>
    </el-dialog>
  </el-card>
</template>

<script>
import { Dialog, Switch, Radio, RadioGroup } from 'element-ui';

export default {
    components: {
        ElDialog: Dialog,
        ElSwitch: Switch,
        ElRadio: Radio,
        ElRadioGroup: RadioGroup,
    },
    data() {
        return {
            loading: false,
            form_loading: false,
            tableData: [],
            visible: false,
            id: '',
            autoContractNum: false,
            form: {
                name: '',
                capacity: '',
            },
            rules: {
                name: [
                    { required: true, message: this.$t('Store.Place.storeplace_not_empty'), trigger: 'blur' },
                ],
                capacity: [
                    { required: true, message: this.$t('Store.Place.No_empty_accommodate'), trigger: 'blur' },
                ],
            },
        };
    },
    computed: {},
    watch: {
        visible(val) {
            if (!val) {
                this.$refs.form.clearValidate();
                this.form = {
                    name: '',
                    capacity: '',
                };
            }
        },
    },
    methods: {
        fetchData() {
            this.loading = true;
            API.get(`store/${this.$route.params.id}/place/list`)
                .then(res => {
                    this.tableData = res;
                    this.autoContractNum = res.autoContractNum;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleReset() {
            this.form = {
                name: '',
                capacity: '',
            };
            this.fetchData(1);
        },
        handleEdit(row) {
            if (row) {
                this.form = row;
            }
            this.visible = true;
        },
        postData() {
            this.loading = true;
            API.post(`store/${this.$route.params.id}/place`, this.form)
                .then(() => {
                    $ele.$message.success(this.$t('Message.save'));
                })
                .finally(() => {
                    this.loading = false;
                    this.visible = false;
                    this.form_loading = false;
                    this.fetchData();
                });
        },
        putData() {
            this.loading = true;
            this.id = this.form.id;
            this.$delete(this.form, 'active');
            this.$delete(this.form, 'id');
            API.put(`store/${this.$route.params.id}/place/${this.id}`, this.form)
                .then(() => {
                    $ele.$message.success(this.$t('Message.save'));
                })
                .finally(() => {
                    this.loading = false;
                    this.visible = false;
                    this.form_loading = false;
                    this.fetchData();
                });
        },
        handleBack() {
            this.$router.back();
        },
        onSubmit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    if (this.form.id) this.putData();
                    else this.postData();
                }
            });
        },
        handleDelete(index, row) {
            $ele
                .$confirm(this.$t('Store.Place.Confirm_del_information'), this.$t('Common.tip'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    cancelButtonText: this.$t('Common.cancel'),
                    type: 'warning',
                })
                .then(() => {
                    API.delete(`store/${this.$route.params.id}/place/${row.id}/active`).then(() => {
                        $ele.$message.success(this.$t('Message.delete_success'));
                        this.fetchData();
                    });
                })
                .catch(() => {
                    $ele.$message.info(this.$t('Common.message.canceldel'));
                });
        },
        handleRestore(index, row) {
            $ele
                .$confirm(this.$t('Store.Place.Confirm_recover_place'), this.$t('Common.tip'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    cancelButtonText: this.$t('Common.cancel'),
                    type: 'warning',
                })
                .then(() => {
                    API.put(`store/${this.$route.params.id}/place/${row.id}/active`).then(() => {
                        $ele.$message.success(this.$t('Common.message.successRestore'));
                    });
                })
                .catch(() => {
                    $ele.$message.info(this.$t('Common.message.canceldel'));
                });
        },
    },
    created() {
        this.fetchData();
    },
};
</script>
